export const contactBoardList = [
    {
        id: "1",
        name: "Shanta Prakash Shrestha",
        contact: "9851021785",
        post: "Member",
        nName: 'शान्त प्रकाश श्रेष्ठ',
        nContact: '९८५१०२१७८५',
        nPost: 'संरक्षक',
    },
    {
        id: "2",
        name: "Juju Man Shrestha",
        contact: "9841501438",
        post: "Member",
        nName: 'जुजुमान श्रेष्ठ',
        nContact: '९८४१५०१४३८',
        nPost: 'पुलाम्ह मू नाय',
    },
    {
        id: "3",
        name: "Binod Maharjan",
        nName: "विनोद महर्जन",
        contact: "9851159446",
        nContact: "९८५११५९४४६",
        post: "Member",
        nPost: "नि.मू. नाय"
    },
    {
        id: "4",
        name: "Suresh Saiju",
        contact: "9851168850",
        post: "Member",
        nName: 'सुरेश सैंजु',
        nContact: '९८५११६८८५०',
        nPost: 'मू नाय',
    },
    {
        id: "5",
        name: "Amar Kaji Shrestha",
        contact: "9851062374",
        post: "Member",
        nName: 'अमर काजी श्रेष्ठ',
        nContact: '९८५१०६२३७४',
        nPost: 'मू-न्वकु',
    },
    {
        id: "6",
        name: "Dharma Narayan Maharjan",
        contact: "9840051782",
        post: "Member",
        nName: 'धर्म नारायण महर्जन',
        nContact: '९८४००५१७८९',
        nPost: 'मू-छ्याञ्जे',
    },
    {
        id: "7",
        name: "Satya Narayan Shrestha",
        contact: "9851094531",
        post: "Member",
        nName: 'सत्य नारायण श्रेष्ठ',
        nContact: '९८५१०९४५३१',
        nPost: 'छ्याञ्जे',
    },
    {
        id: "8",
        name: "Surya Laxmi Maharjan",
        contact: "9843177239",
        post: "Member",
        nName: 'सुर्यलक्ष्मी महर्जन',
        nContact: '९८४३१७७२३९',
        nPost: 'मू-दॉभरी',
    },
    {
        id: "9",
        name: "Bhawani Pradhan",
        contact: "9845070654",
        post: "Member",
        nName: 'भवानी प्रधान',
        nContact: '९८४५०७०६५४',
        nPost: 'दॉभरी',
    },
    {
        id: "10",
        name: "Subarna Manandhar",
        contact: "9851083228",
        post: "Member",
        nName: 'सुवर्ण मानन्धर',
        nContact: '९८५१०८३२२८',
        nPost: 'मू-दुज',
    },
    {
        id: "11",
        name: "Dr. Rasila Amatya",
        contact: "9851004821",
        post: "Member",
        nName: 'डा. रशिला अमात्य',
        nContact: '९८५१००४८२१',
        nPost: 'मू-दुज',
    },
    {
        id: "12",
        name: "Tulasi Narayan Shrestha",
        contact: "9841645199",
        post: "Member",
        nName: 'तुलसी ना. श्रेष्ठ',
        nContact: '९८४१६४५१९९',
        nPost: 'मू-दुज',
    },
    {
        id: "13",
        name: "Ramkrishna Maharjan",
        contact: "9851212753",
        post: "Member",
        nName: 'रामकृष्ण महर्जन',
        nContact: '९८५१२१२७५३',
        nPost: 'मू-दुज',
    },
    {
        id: "14",
        name: "Mamata Shakya",
        contact: "9843077230",
        post: "Member",
        nName: 'ममता शाक्य',
        nContact: '९८४३०७७२३०',
        nPost: 'मू-दुज',
    },
    {
        id: "15",
        name: "Binu Karmacharya",
        contact: "9841278390",
        post: "Member",
        nName: 'बिनु कर्माचार्य',
        nContact: '९८४१३७८३९०',
        nPost: 'मू-दुज',
    },
    {
        id: "16",
        name: "Dipak Mulmi Shrestha",
        contact: "9841331199",
        post: "Member",
        nName: 'दिपक मूल्मी श्रेष्ठ',
        nContact: '९८४१३३११९९',
        nPost: 'मू-दुज',
    },
    {
        id: "17",
        name: "Akkal Das Maharjan",
        contact: "9841350243",
        post: "Member",
        nName: 'अक्कल दास महर्जन',
        nContact: '९८४१३५०२४३',
        nPost: 'मू-दुज',
    },
    {
        id: "18",
        name: "Basanta Nakarmi",
        contact: "9841353585",
        post: "Member",
        nName: 'बसन्त नकर्मी',
        nContact: '९८४१३५३५८५',
        nPost: 'मू-दुज',
    },
    {
        id: "19",
        name: "Bijaya Malla",
        contact: "9845072076",
        post: "Member",
        nName: 'बिजय मल्ल',
        nContact: '९८४५०७२०७६',
        nPost: 'मू-दुज',
    },
    {
        id: "20",
        name: "Tirtha Bhakta Shyaula",
        contact: "9841216366",
        post: "Member",
        nName: 'तिर्थ भक्त स्याउला',
        nContact: '९८४१३५३५८५',
        nPost: 'मू-दुज',
    },
];

export const kawakajiList = [
    {
        id: '1',
        name: '',
        contact: '',
        post: '',
        nName: 'सुरेश सैंजु',
        nContact: '९८५११६८८५०',
        nPost: 'मू कव कजि',
    },
    {
        id: '2',
        name: '',
        contact: '',
        post: '',
        nName: 'श्री कृष्ण महर्जन',
        nContact: '९८४१७५२५८३',
        nPost: 'नेवा सांस्कृतिक स्वायत्त क्षेत्र',
    },
    {
        id: '3',
        name: '',
        contact: '',
        post: '',
        nName: 'कृष्णबहादुर श्रेष्ठ',
        nContact: '९८५११३९९४५',
        nPost: 'कृषि कव कजि',
    },
    {
        id: '4',
        name: '',
        contact: '',
        post: '',
        nName: 'डा. रसिला अमात्य',
        nContact: '९८५१००४८२१',
        nPost: 'स्वास्थ्य कव',
    },
    {
        id: '5',
        name: '',
        contact: '',
        post: '',
        nName: 'जुजुभाई महर्जन',
        nContact: '९८५१०६७४९५',
        nPost: 'शिक्षा कव',
    },
    {
        id: '6',
        name: '',
        contact: '',
        post: '',
        nName: 'तीर्थ स्याउला',
        nContact: '९८४१२९६३३३',
        nPost: 'भाषा लिपी',
    },
    {
        id: '7',
        name: '',
        contact: '',
        post: '',
        nName: 'कृष्णप्रसाद प्रजापति',
        nContact: '९८१८३४५५४४',
        nPost: 'संस्कृति',
    },
    {
        id: '8',
        name: '',
        contact: '',
        post: '',
        nName: 'योगी स्यास्य श्रेष्ठ',
        nContact: '९८०३४६७३९६',
        nPost: 'लमी कव',
    },
    {
        id: '9',
        name: '',
        contact: '',
        post: '',
        nName: 'धर्म नारायण महर्जन',
        nContact: '९८६०३७०१६८',
        nPost: 'सम्पदा कव',
    },
    {
        id: '10',
        name: '',
        contact: '',
        post: '',
        nName: 'सरल गोपाल महर्जन',
        nContact: '९८४३०७४६४१',
        nPost: 'ल्यायम्ह कव',
    },
    {
        id: '11',
        name: '',
        contact: '',
        post: '',
        nName: 'राम प्रसाद श्रेष्ठ',
        nContact: '९८५१०६३९०८',
        nPost: 'सुचं संचार',
    },
    {
        id: '12',
        name: '',
        contact: '',
        post: '',
        nName: 'सुरेन्द्र श्रेष्ठ',
        nContact: '९८५११३४६६१',
        nPost: 'सांगीतिक',
    },
    {
        id: '13',
        name: '',
        contact: '',
        post: '',
        nName: 'निमेषमान श्रेष्ठ',
        nContact: '९८४१७०७०९०',
        nPost: 'व्यापार नेता',
    },
    {
        id: '14',
        name: '',
        contact: '',
        post: '',
        nName: 'बिध्या श्रेष्ठ',
        nContact: '९८४१३१६७८९',
        nPost: 'मयजु कव',
    },
    {
        id: '15',
        name: '',
        contact: '',
        post: '',
        nName: 'अस्तेन्द्र महर्जन',
        nContact: '९८०३४१०५३६',
        nPost: 'सहलह व अनुसङ्घन',
    },
    {
        id: '16',
        name: '',
        contact: '',
        post: '',
        nName: 'विश्वमान श्रेष्ठ',
        nContact: '९८४१६०११७५',
        nPost: 'मृत्यु व दाहसंस्कार',
    },
    {
        id: '17',
        name: '',
        contact: '',
        post: '',
        nName: 'रमेश जोशी',
        nContact: '९८४९१३३८१५',
        nPost: 'अन्तर्राष्ट्रिय स्वपु कव',
    },
    {
        id: '18',
        name: '',
        contact: '',
        post: '',
        nName: 'डा. शान्तवीर सिन तुलाधर',
        nContact: '९८०८८६७०१७/ ४४७९१२१०१६६९',
        nPost: 'दुर्गालाल हनेज्या',
    },
];
